var SCM = SCM || {};

SCM.Focus = (function ($) {
    var FocusableSelectorString =
        'a[href], button, textarea, select, input:not([type="hidden"]), iframe';
    return {
        FocusableSelectorString: FocusableSelectorString,
        trap: _trap,
        release: _release
    };

    /**
     * Trap focus in the specified wrapper element
     * @param {string|HTMLElement|JQuery} wrapper
     */
    function _trap(wrapper) {
        var $wrapper = $(wrapper).first();
        _saveFocus($wrapper);
        var $allFocusableElements = _getPotentiallyFocusableElements($wrapper);
        _captureTabbing($wrapper, $allFocusableElements);
        _focusFirstVisibleElement($allFocusableElements);
    }

    /**
     * Release the focus trap from the specified wrapper element, and
     * restore focus to the element that was focused before the trap was set
     * @param {string|HTMLElement|JQuery} wrapper
     */
    function _release(wrapper) {
        var $wrapper = $(wrapper).first();
        if (!$wrapper.length) {
            return;
        }
        _releaseTabbing($wrapper);
        _restoreFocus($wrapper);
    }

    function _saveFocus($wrapper) {
        var $currentlyFocusedElement = $(document.activeElement).first();
        $wrapper.data('lastFocusedElement', $currentlyFocusedElement);
    }

    function _restoreFocus($wrapper) {
        var $newFocus = _getClosestFocusableElement($wrapper.data('lastFocusedElement'));
        if (!$newFocus || !$newFocus.length) {
            // No real element to return focus to (e.g. the trigger was an
            // anchor/button the browser never focused, so activeElement
            // was <body>, or the trigger was inside a subtree that is now
            // hidden). Leave focus where the browser puts it rather than
            // synthesising a target, which can surface unrelated page
            return;
        }
        $newFocus.first().trigger('focus');
    }

    function _focusFirstVisibleElement($focusableElements) {
        $focusableElements
            .filter(':visible')
            .first()
            .trigger('focus');
    }

    function _releaseTabbing($wrapper) {
        $wrapper.off('keydown.SCM.Focus');
    }

    function _captureTabbing($wrapper, $allFocusableElements) {
        // Note:  This function serves as a closure for all of the focus
        // changing functionality within the specified wrapper for the lifetime
        // of the event handler, so that we don't have to repeatedly discover
        // the focusable elements.
        $wrapper.on('keydown.SCM.Focus', function(e) {
            if (e && (e.key === 'Tab' || e.code === 'Tab')) {
                if (e.shiftKey) {
                    _focusBack($allFocusableElements, e);
                } else {
                    _focusForward($allFocusableElements, e);
                }
            }
        });
    }

    /**
     * Returns any element within the specified element that could potentially
     * receive focus by the browser, if it were visible.
     * Note that the usual definition of "focusable" requires that the element is
     * visible, but we want to include non-visible elements in case they are
     * made visible at some point later.
     * @param {any} $wrapper
     */
    function _getPotentiallyFocusableElements($wrapper) {
        return $wrapper.find(FocusableSelectorString);
    }

    function _focusForward($focusableElements, e) {
        var $visibleElements = $focusableElements.filter(':visible').filter(':not([disabled])');
        if (document.activeElement === $visibleElements.last()[0]) {
            $visibleElements.first().trigger('focus');
            e && e.preventDefault && e.preventDefault();
        }
    }

    function _focusBack($focusableElements, e) {
        var $visibleElements = $focusableElements.filter(':visible').filter(':not([disabled])');
        if (document.activeElement === $visibleElements.first()[0]) {
            $visibleElements.last().trigger('focus');
            e && e.preventDefault && e.preventDefault();
        }
    }

    /**
     * Return the given element if it can receive focus.  If not, walk up the
     * DOM for the first visible focusable ancestor.  Returns an empty jQuery
     * when nothing visible+focusable is found in the element or its ancestors.
     *
     * We deliberately do NOT consult siblings.  When the saved focus is inside
     * a subtree that has just been hidden (e.g. a modal that is closing), a
     * sibling search will walk all the way up to the body and surface an
     * unrelated top-of-document focusable like the .skipnav link, which scrolls
     * the viewport to the top when focused.
     * @param {any} $element
     */
    function _getClosestFocusableElement($element) {
        $element = $($element).first();
        while ($element.length && !$element.is('body')) {
            if ($element.is(FocusableSelectorString) && $element.is(':visible')) {
                return $element;
            }
            $element = $element.parent();
        }
        return $();
    }

})(jQuery);
